import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { interfaceActions } from '../../../../common/redux/actions';
import {
  getAllExecutors,
  // deleteSelectedTemplates,
} from '../../redux/actions/executorsActions';
import {
  updateFilterFieldsExecutors,
  searchExecutors,
  changeTypeListExecutors,
  resetFiltersExecutors,
} from '../../redux/actions/filters';

import * as URLs from '../../../../common/constants/systemUrls';
import ExecutorsTable from '../../components/Table/ExecutorsTable';
import { Typography, Button, Avatar } from 'antd';
// , Modal
// import Filters from '../../components/Filters/Filters';
import history from '../../../../common/history';
// import Footer from '../../../../common/hoc/withFooter';
import moment from 'moment';
import './Executors.css';
// import TemplatesFooter from '../../components/TemplatesFooter';
// import { confirmDeleteSelected } from '../../components/ExecutorCard/popup/confirm';
// const confirm = Modal.confirm;
import { IMAGE_SERVER } from '../../../../common/constants/systemUrls';
import TopPanel from '../../components/Executors/TopPanel/TopPanel';

const { setCaption } = interfaceActions;
const { Text } = Typography;

class Executors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerCols: {
        photo: true,
        company: true,
        subject: true,
        email: true,
        orders: true,
        date: true,
      },
      tableColumnsLen: 0,
      pagination: {
        pages: 3,
      },
      selectedRowKeys: [],
      executors: [],
    };
    this.state.tableColumnsLen = this.getTableColumnsLen();
  }
  componentDidMount() {
    this.updateData();
    // this.setCaption(true);
    this.props.getAllExecutors();
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.executors !== this.props.executors ||
      prevProps.filters !== this.props.filters
    ) {
      this.updateData();
    }
  }
  // setCaption(flagUpdate = false) {
  //   if (flagUpdate) {
  //     this.props.setCaption({
  //       enabled: true,
  //       mainCaption: 'Мои исполнители',
  //       breadCrumbs: [
  //         {
  //           path: '/' + URLs.CONTROL_PANEL,
  //           breadcrumbName: 'Панель управления',
  //         },
  //         {
  //           path: '/executors',
  //           breadcrumbName: 'Мои исполнители',
  //         },
  //       ],
  //     });
  //   }
  // }
  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };
  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];
    let cols = [
      {
        title: '',
        dataIndex: 'photo',
        key: 'photo',
        width: 65,
        render: (photo, record) => (
          <Avatar
            shape="square"
            size="large"
            src={photo ? `${IMAGE_SERVER}${photo}` : null}
            icon="user"
          />
        ),
      },
      {
        title: 'Наименование',
        dataIndex: 'company',
        key: 'company',
        render: company => (
          <Fragment>
            <div>
              <Text style={{ color: '#323232' }}>
                {company.name ? company.name : '—'}
              </Text>
            </div>
            <div>
              <Text style={{ color: '#9b9b9b' }}>
                ИНН {company.inn ? company.inn : '—'}
              </Text>
            </div>
          </Fragment>
        ),
      },
      {
        title: 'E-mail',
        dataIndex: 'company',
        key: 'email',
        render: company => (
          <Fragment>
            <div>
              <Text style={{ color: '#323232' }}>
                {company.email ? company.email : '—'}
              </Text>
            </div>
            <div>&nbsp;</div>
          </Fragment>
        ),
      },
      {
        title: 'Заказы',
        dataIndex: 'orders',
        key: 'orders',
        render: orders => {
          return (
            <span>
              <Text style={{ color: '#323232' }}>
                Запланированные: {orders && orders.planned}
              </Text>
              <br />
              <Text style={{ color: '#9b9b9b' }}>
                Архив: {orders && orders.archived}
              </Text>
            </span>
          );
        },
      },
      {
        title: 'Дата изменения',
        dataIndex: 'date',
        key: 'date',
        width: '180px',
        render: date => (
          <Fragment>
            <div>
              <Text style={{ color: '#323232' }}>
                {moment(
                  new Date(date.changed ? date.changed : date.created)
                ).format('DD.MM.YYYY')}
              </Text>
            </div>
            <div>
              <Text style={{ color: '#9b9b9b' }}>
                Создан:{' '}
                {date.created
                  ? moment(new Date(date.created)).format('DD.MM.YYYY')
                  : '—'}
              </Text>
            </div>
          </Fragment>
        ),
        sorter: (a, b) => {
          return (
            a.date &&
            a.date.changed &&
            a.date.changed.localeCompare(b.date.changed)
          );
        },
      },
      /*

      {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        render: status => (
          <span>
            <Text>{status.name}</Text>
            <br />
            <Text type="secondary">{status.data}</Text>
          </span>
        ),
      },

      {
        title: '',
        dataIndex: '',
        key: '',
        render: () => {},
      },

      {
        title: 'Дата изменения',
        dataIndex: 'data',
        key: 'data',
        render: data => (
          <span>
            <Text>{data.changeData}</Text>
            <br />
            <Text type="secondary">{data.creationData}</Text>
          </span>
        ),
      },
      */
    ];
    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }
    return filteredCols;
  };
  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e),
      },
    }));
  };
  onChangeTable = (pagination, filters) => {};

  onChangeTypeList = e => {
    let status = e.target.value;
    this.props.changeTypeListExecutors(status);
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.props.searchExecutors(value);
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        this.props.history.push(
          '/' + URLs.SYSTEM_SETTINGS + `/executors/${row.id}`
        );
      },
    };
  };

  onChangeRowSelection = row => {
    this.setState(state => ({
      ...state,
      selectedRowKeys: row,
    }));
  };

  updateData = () => {
    if (this.props.executors) {
      const executors =
        this.props.filters.typeList && this.props.filters.typeList !== 'all'
          ? this.props.executors.filter(
              item => item.status === this.props.filters.typeList
            )
          : this.props.executors;

      this.setState({
        executors,
      });
    } else {
      if (this.state.executors) {
        this.setState({
          executors: [],
        });
      }
    }
  };

  render() {
    const { executors } = this.state;

    return (
      <div id="executors">
        <div className="executors-create">
          <Button
            onClick={() =>
              history.push('/' + URLs.SYSTEM_SETTINGS + '/executors/add')
            }
            size="large"
            type="primary"
          >
            Добавить исполнителя
          </Button>
        </div>
        <div className="executors">
          <div className="executors__search">
            <TopPanel
              typesList={this.props.executorsTypes}
              stat={this.props.executorsStat}
              totalExecutors={
                this.props.executors ? this.props.executors.length : 0
              }
              onChangeTypeList={this.onChangeTypeList}
              onChangeSearch={this.onChangeSearch}
            />
          </div>
          {/* todo next release <div className="templates__filters">
            <Filters
              // showFilterAll={showFilterAll}
              // filter={filter}
              showDrawer={this.showDrawer}
              toggleAllFilter={this.toggleAllFilter}
              handleFiltersChange={this.handleFiltersChange}
            />
            </div> */}
          <ExecutorsTable
            renderColumns={this.renderColumns}
            tableColumnsLen={this.state.tableColumnsLen}
            executors={executors}
            pages={this.state.pagination.pages}
            isLoading={this.props.isLoading}
            changePaginationSize={this.changePaginationSize}
            onChangeTable={this.onChangeTable}
            handleClickRow={this.handleClickRow}
            // selectedRowKeys={this.state.selectedRowKeys}
            onChangeRowSelection={this.onChangeRowSelection}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  state => {
    const { Executors: executors, Filters: filters } = state.Executors;
    // const { profileFilters } = state.SystemSettings.filters;
    return {
      isLoading: executors.isLoading,
      executors:
        filters.count > 0 ? executors.filterExecutors : executors.allExecutors,
      executorsStat:
        filters.count > 0
          ? executors.filterExecutorsStat
          : executors.allExecutorsStat,
      executorsTypes: executors.executorsTypes,
      filters,
    };
  },
  {
    setCaption,
    getAllExecutors,
    updateFilterFieldsExecutors,
    searchExecutors,
    changeTypeListExecutors,
    resetFiltersExecutors,
    // deleteSelectedTemplates,
  }
)(Executors);
